import React, { useEffect, useState } from 'react'
import FhirLoader from '../../../../FhirLoader'
import { useHistory } from 'react-router-dom'
import {DiagnosticReport as FHIRDiagnosticReport} from '@teschglobal/tg-fhir-react-components/dist/types'
import { DiagnosticReport } from '@teschglobal/tg-fhir-react-components'
import { DiagnosticReportBundle } from '../../../../../types/FHIRTypes/Bundle'

import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'




type DiagnosticReportDetailProps = {
    diagnosticReportDetailId: string | undefined;
}



const DiagnosticReportDetail: React.FC<DiagnosticReportDetailProps> = ({ diagnosticReportDetailId}) => {
    const [resource, setResource] = useState<FHIRDiagnosticReport | null>(null)
    const { patientAccessFhirConfig } = useFhirConfig()
    const history = useHistory()
      const {
    data: diagnosticReport,
    isFetching,
    isLoading,
    isError
  }: UseQueryResult<FHIRDiagnosticReport, Error> =
    useFhirResourceById('Patient Access', diagnosticReportDetailId || '', 'DiagnosticReport')

  if (isFetching || isLoading) {
    return <FhirLoader />
  }

  if (!diagnosticReport || isError) {
    return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
  }


    return (
        <div>
            <section>
                <DiagnosticReport
                    data={diagnosticReport}
                    fhirApiConfig={patientAccessFhirConfig}
                />
            </section>
        </div>
    )
}

export default DiagnosticReportDetail